import React, { useEffect, useState } from "react";

import axios from "axios";

import { useNavigate } from "react-router-dom";
import AttendItem from "./attendance-item";

import { listAction as storeListAction } from "../../network/store/action/BranchResponseAction";
import { useDispatch, useSelector } from "react-redux";
import { formUpdateStatus } from "../../redux/slice/formUpdateSlice";
import {
  attendanceListAction,
  listAction,
} from "../../network/store/action/UserResponseAction";
import { isAfterDate, todayDate } from "../../utils/dateUtil";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
} from "reactstrap";

function UserAttendance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // list of items
  const [resultList, setResultList] = useState([]);
  const [userList, setUserList] = useState([]);
  const showRequestForm = useSelector(formUpdateStatus);
  // progress Dialog
  const [isLoading, setIsLoading] = useState(false);

  const [filterList, setFilterList] = useState([]);
  const [searchVal, setSearchVal] = useState("");

  const [branches, setBranchList] = useState([]);
  const [filterOptions, setfilterOptions] = useState({
    storeId: "",
    startDate: todayDate(),
    userId: "",
    endDate: "",
  });

  useEffect(() => {
    getStores();
    loadDUsers();
    loadData(true);
  }, []);

  useEffect(() => {
    loadDUsers();
    datesValidation();
  }, [filterOptions]);

  const getStores = async () => {
    await dispatch(storeListAction({}, dispatch)).then((response) => {
      if (response.result) {
        setBranchList(response.result);
      }
    });
  };

  const datesValidation = () => {
    let to = filterOptions.endDate;

    // if (new Date(formData.startDate) > new Date(to)) {
    //   alert("Select Valid Dates");
    // }

    if (
      filterOptions.startDate.length > 0 &&
      filterOptions.endDate.length > 0 &&
      !isAfterDate(filterOptions.startDate, to)
    ) {
      alert("Select Valid Dates");
    } else {
      loadData();
    }
  };

  const loadDUsers = async () => {
    await dispatch(
      listAction(
        {
          orgId: filterOptions.storeId,
          roleId: "3,4,7",
        },
        dispatch
      )
    ).then((reponse) => {
      if (reponse.result) {
        setUserList(reponse.result);
      } else {
        setUserList([]);
      }
    });
  };

  const handleChanges = (e) => {
    if (e.target.name === "storeId") {
      branches.findIndex((obj) => obj.id === e.target.value);
      setfilterOptions({
        ...filterOptions,
        storeId: e.target.value,
        userId: "",
      });
    } else if (e.target.name === "startDate" && e.target.value === "") {
      setfilterOptions({
        ...filterOptions,
        startDate: e.target.value,
        endDate: "",
      });
    } else {
      setfilterOptions({ ...filterOptions, [e.target.name]: e.target.value });
    }
  };
  const loadData = async () => {
    await dispatch(
      attendanceListAction(
        {
          dated: filterOptions.startDate,
          storeId: filterOptions.storeId,
          endDate: filterOptions.endDate,
          userId: filterOptions.userId,
        },
        dispatch
      )
    ).then((reponse) => {
      setFilterList([]);

      if (reponse.result) {
        setResultList(reponse.result);
      } else {
        setResultList([]);
      }
    });
  };

  function handleSearchClick(e) {
    const searchTerm = e.target.value;
    setSearchVal(searchTerm);
    if (searchTerm === "") {
      setResultList(resultList);
      setFilterList([]);
    } else {
      const filterBySearch = resultList.filter((item) => {
        if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          return item;
        }
      });
      setFilterList(filterBySearch);
    }
  }

  return (
    <main className="container-fluid dashboard">
      <div className="row m-3">
        <div className="col-md-3">
          <div className="form-group">
            <label>Branch</label>
            <select
              name="storeId"
              className="form-select"
              onChange={(e) => handleChanges(e)}
              value={filterOptions.storeId}
            >
              <option value={""}>{"All Branches"}</option>
              {branches &&
                branches.length > 0 &&
                branches.map((item, index) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label>Employee</label>
            <select
              name="userId"
              className="form-select"
              onChange={(e) => handleChanges(e)}
              value={filterOptions.userId}
            >
              <option value={""}>{"--Select Executive--"}</option>
              {userList &&
                userList.length > 0 &&
                userList.map((item, index) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.name}
                      {"  / "}
                      {item.role_id == 7 ? (
                        <h6 style={{ color: "green" }}>Delivery Executive</h6>
                      ) : item.role_id == 4 ? (
                        <>Store Executive</>
                      ) : (
                        <>Store Employee</>
                      )}{" "}
                      - {item.db_status}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        <div
          className={
            filterOptions.startDate.length > 0 ? "col-md-5" : "col-md-2"
          }
        >
          <Row>
            <Col>
              <FormGroup>
                <Label for="startDate">Date</Label>
                <Input
                  type="date"
                  name="startDate"
                  id="startDate"
                  placeholder=""
                  value={filterOptions.startDate}
                  onChange={handleChanges}
                  // min={new Date().toISOString().split("T")[0]}
                />
              </FormGroup>
            </Col>
            {filterOptions.startDate.length > 0 && (
              <Col>
                <FormGroup>
                  <Label for="endDate">To Date</Label>
                  <Input
                    type="date"
                    name="endDate"
                    id="endDate"
                    placeholder=""
                    value={filterOptions.endDate}
                    onChange={handleChanges}
                    // min={new Date().toISOString().split("T")[0]}
                  />
                </FormGroup>
              </Col>
            )}
          </Row>
        </div>

        <div className="col-md-12 card-1 table-responsive">
          <table className="table table-striped table-bordered border-sm  mt-2 align-middle">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Employee Name</th>
                <th scope="col">Branch</th>
                <th scope="col">Login Time</th>
                {/* <th scope="col">Login Location</th> */}
                <th scope="col">Logout Time</th>
                {/* <th scope="col">Logout Location</th> */}
                <th scope="col">Work Hours</th>
                <th scope="col">Total Entries</th>
              </tr>
            </thead>

            {searchVal === "" && resultList && resultList.length > 0 ? (
              <tbody>
                {resultList.map((item, i) => {
                  return <AttendItem item={item} key={item.id} />;
                })}
              </tbody>
            ) : filterList.length > 0 ? (
              <tbody>
                {filterList.map((item, i) => {
                  return <AttendItem item={item} key={item.id} />;
                })}
              </tbody>
            ) : (
              <p>No Data found</p>
            )}
          </table>
        </div>
      </div>
    </main>
  );
}

export default UserAttendance;
